<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Change username</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <div class="flex flex-col gap-2">
        <Input
          v-model="username"
          size="xl"
          label="Username"
          :disabled="loading"
        />
        <UsernameValidation
          :show="showValidation"
          :checking="checkingAvailability"
          :available="isAvailable"
        />
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import type { User } from '@/shared/graphql/legacy/generated'
import UsernameValidation from './UsernameValidation.vue'
import { useChangeUsername } from './useChangeUsername'

const { close } = useSheet()

const props = defineProps<{
  user: User
}>()

const {
  username,
  isAvailable,
  checkingAvailability,
  showValidation,
  loading,
  canSave,
  save,
} = useChangeUsername(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
